import React, {useEffect} from 'react';
import close from "../../../images/close.svg";
import {Field, Formik} from "formik";
import arrowDown from "../../../images/input-arrow.svg";
import infoIcon from "../../../images/info-circle.svg";
import {useTheme} from "../../../App";
import {connect} from "react-redux";
import {getCommonData} from "../../../redux/data/data-thunks";
import {SHIPYARDS, YACHT_TYPES} from "../../../redux/data/data-types";
import * as Yup from "yup";
import {dataApi} from "../../../redux/data/data-api";
import {useTranslation} from "react-i18next";
import {isCyrilic} from "../../../utils";

const CreateModel = ({closeModal, ...props}) => {
  const {isDark} = useTheme()
  const {t} = useTranslation()
  useEffect(() => {
    props.getCommonData(YACHT_TYPES)
    props.getCommonData(SHIPYARDS)
  }, [])
  return (
    <div style={{width: 565}} className={`modal ${isDark && 'modal__dark'}`}>
      <button onClick={closeModal} className="modal__close">
        <img src={close} alt=""/>
      </button>
      <h5 className="modal__title pr-40">{t('addNewModel')}</h5>
      <Formik
        initialValues={{
          model: '',
          type: '',
          type_id: '',
          shipyard: '',
          shipyard_id: '',
          length: '',
          width: ''
        }}
        validationSchema={Yup.object({
          model: Yup.string()
            .required(t('enterNameModel')),
          type: Yup.string()
            .required(t('selectYachtType')),
        })}
        onSubmit={async (values, {setFieldError, setFieldValue, resetForm}) => {
          let isAnyError = false
          if(values.shipyard.length > 0 && !props.shipyards.find(s => s.name === values.shipyard)) {
            isAnyError = true
            setFieldError('shipyard', t('shipyardNotFound'))
          }
          if(!isCyrilic(values.model)) {
            isAnyError = true
            setFieldError('model', `${t('enter')} ${t('model')} ${t('onlyEnglish')}`)
          }
          if(!isAnyError) {
            try {
              await dataApi.createModel(values.model, props.shipyards.find(s => s.name === values.shipyard)?.id ?? null,
                values.type_id, values.length, values.width)
              closeModal()
            } catch (e) {
              console.log(e)
            }
          }
        }}>
        {({values, handleChange, setFieldValue, errors, submitCount, ...formikProps}) => {
          errors = submitCount > 0 ? errors : {}
          return <>
            <div className="modal__sections">
              <div className={'modal__section mt-0'}>
                <div className="modal__inputItem mt-0">
                  <p className="modal__label w-80">{t('model')}: </p>
                  <div className="modal__inputWrapper w-100">
                    <Field autoComplete="off" placeholder={t('enterModel')} value={values.model} id={'model'}
                           onChange={e => {
                             if (e.target.value.length < 40) {
                               handleChange(e)
                             }
                           }} type="text" className={`modal__input w-100 ${errors.model && 'modal__inputError'}`}/>
                  </div>
                </div>
                {errors.model && <div className={'modal__inputItem mt-0'}>
                  <p className="modal__label w-80"/>
                  <p className="modal__errorText">{errors.model}</p>
                </div>}
                <div className="modal__inputItem">
                  <p className="modal__label w-80">{t('yachtType')}:</p>
                  <div className="modal__inputWrapper w-100">
                    <Field placeholder={t('enterYachtType')} value={values.type} id={'type'}
                           onChange={() => {
                           }} type="text" className={`modal__input w-100 ${errors.type && 'modal__inputError'}`}/>
                    <div className="modal__list">
                      <div className="modal__listItems">
                        {props.yachtTypes.map((y, index) => <button className="modal__listItem"
                                                                    onClick={() => {
                                                                      setFieldValue('type', y.name)
                                                                      setFieldValue('type_id', y.id)
                                                                    }} key={index}>
                          {y.name}
                        </button>)}
                      </div>
                    </div>
                    <button className="modal__arrowIcon">
                      <img src={arrowDown} alt=""/>
                    </button>
                  </div>
                </div>
                {errors.type && <div className={'modal__inputItem mt-0'}>
                  <p className="modal__label w-80"/>
                  <p className="modal__errorText">{errors.type}</p>
                </div>}
                <div className="modal__inputItem">
                  <p className="modal__label w-80">Shipyard:</p>
                  <div className="modal__inputWrapper w-100">
                    <Field placeholder={t('notChosen')} value={values.shipyard} id={'shipyard'}
                           onChange={e => {
                             handleChange(e)
                             props.getCommonData(SHIPYARDS, e.target.value)
                           }} type="text" className={`modal__input w-100 ${errors.shipyard && 'modal__inputError'}`}/>
                    <div className="modal__list">
                      <div className="modal__listItems">
                        {props.shipyards.filter(s => s.name.indexOf(values.shipyard) !== -1).map((s, index) => <button className="modal__listItem"
                                                                                                                       onClick={() => {
                                                                                                                         setFieldValue('shipyard', s.name)
                                                                                                                         setFieldValue('shipyard_id', s.id)
                                                                                                                       }}
                                                                                                                       key={index}>
                          {s.name}
                        </button>)}
                      </div>
                    </div>
                    <button className="modal__arrowIcon">
                      <img src={arrowDown} alt=""/>
                    </button>
                  </div>
                </div>
                {errors.shipyard && <div className={'modal__inputItem mt-0'}>
                  <p className="modal__label w-80"/>
                  <p className="modal__errorText">{errors.shipyard}</p>
                </div>}
                <div className="modal__inputItem">
                  <p className="modal__label w-80">{t('length')}:</p>
                  <div className="modal__inputWrapper w-130">
                    <Field placeholder={'0.00'} value={values.length} id={'length'}
                           onChange={(e) => {
                             if (!isNaN(e.target.value) && e.target.value.length < 6) {
                               handleChange(e)
                             }
                           }} className={`modal__input w-130 ${errors.length && 'modal__inputError'}`}/>
                    <button className="modal__arrowIcon">
                      <img src={arrowDown} alt=""/>
                    </button>
                  </div>
                  <p className="modal__label w-80 ml-15">{t('metres')}</p>
                </div>
                {errors.length && <div className={'modal__inputItem mt-0'}>
                  <p className="modal__label w-80"/>
                  <p className="modal__errorText">{errors.length}</p>
                </div>}
                <div className="modal__inputItem">
                  <p className="modal__label w-80">{t('width')}:</p>
                  <div className="modal__inputWrapper w-130">
                    <Field placeholder={'0.00'} value={values.width} id={'width'}
                           onChange={(e) => {
                             if (!isNaN(e.target.value) && e.target.value.length < 6) {
                               handleChange(e)
                             }
                           }} className={`modal__input w-130 ${errors.width && 'modal__inputError'}`}/>
                    <button className="modal__arrowIcon">
                      <img src={arrowDown} alt=""/>
                    </button>
                  </div>
                  <p className="modal__label w-80 ml-15">{t('metres')}</p>
                </div>
                {errors.width && <div className={'modal__inputItem mt-0'}>
                  <p className="modal__label w-80"/>
                  <p className="modal__errorText">{errors.width}</p>
                </div>}
              </div>
            </div>
            <div className="modal__actions mt-16">
              <button onClick={formikProps.handleSubmit} className="submit-button">
                {t('save')}
              </button>
              <button onClick={closeModal} className={`commonBtn ${isDark && 'commonBtn__dark'}`}>
                <span className={'commonBtn__label'}>{t('cancel')}</span>
              </button>
            </div>
          </>
        }}
      </Formik>
    </div>
  );
};

const mapStateToProps = (state) => ({
  yachtTypes: state.dataReducer.yachtTypes,
  shipyards: state.dataReducer.shipyards
})

export default connect(mapStateToProps, {getCommonData})(React.memo(CreateModel))
